import Icon from 'veui/components/Icon'
import { IconFilm } from 'dls-icons-vue'

Icon.register('film', IconFilm)
